import biomass from './biomass.webp'
import district from './district.webp'
import electric from './electric.webp'
import gas from './gas.webp'
import oil from './oil.webp'
import other from './other.webp'
import radiators from './radiators.webp'
import underfloor from './underfloor.webp'

export const energySourceIcons = {
  biomass,
  district,
  electric,
  gas,
  oil,
  other,
  radiators,
  underfloor,
} as const

export type EnergySourceIconKey = keyof typeof energySourceIcons
